import React from 'react';
import { useTranslation } from 'react-i18next';

interface DefaultImageIconProps {
  className?: string;
  onClick?: () => void;
}

/**
 * VisSynth默认图片图标组件
 * 用于在没有图片时显示的默认图标
 */
const DefaultImageIcon: React.FC<DefaultImageIconProps> = ({ className = '', onClick }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`w-full aspect-[1/1] bg-gray-600/00 rounded flex items-center justify-center cursor-pointer hover:opacity-90 transition-opacity relative ${className}`}
      onClick={onClick}
    >
      {/* VisSynth主题SVG图标 */}
      <svg
        className="w-full h-full opacity-60"
        viewBox="0 0 400 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* 背景 */}
        {/*</svg><rect width="400" height="400" fill="#080b0fff" />*/}

        {/* 主圆形背景 */}
        <circle cx="200" cy="200" r="120" stroke="#424754ff" strokeWidth="2" />

        {/* VisSynth文字 */}
        <text
          x="200"
          y="200"
          textAnchor="middle"
          dominantBaseline="middle"
          fill="#6B7280"
          fontSize="32"
          fontWeight="bold"
        >
          VisSynth
        </text>
      </svg>
    </div>
  );
};

export default DefaultImageIcon;
